export default __webpack_public_path__ + "static/media/2a.1a8e073b.jpg";